import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash.isnil';
import { UNTRANSCRIBABLE_MODAL } from '../../../../../../constants/reading/TroConstants';
import Word from '../../word/Word';
import ConfirmationModal from '../modals/confirmationModal/ConfirmationModal';
import { getSentencesWithMergedMarks } from '../../../../../../utils/reading/troUtils';
import './TroBookContent.scss';
import { generateReactKey } from '../../../../../../utils/shared/commonUtils';

const TroBookContent = ({
    listOfSentences,
    setEditMode,
    startPosition,
    mergedEndPosition,
    getWidget,
    onPressHoldHandler,
    onClickHandler,
    getMarksClassNames,
    closeConfirmationPopup,
    confirmationModalType,
    onRevert,
}) => {
    const contentReference = useRef();

    const onCloseUntranscribableModal = () => {
        setEditMode(true);
        closeConfirmationPopup(true);
    };
    const sentencesWithMergedMarks = getSentencesWithMergedMarks(listOfSentences);

    return (
        <div className="tro-text-wrapper">
            <ConfirmationModal
                confirmationModalType={confirmationModalType}
                closeModal={
                    confirmationModalType === UNTRANSCRIBABLE_MODAL
                        ? onCloseUntranscribableModal
                        : closeConfirmationPopup
                }
                isShown={!isNil(confirmationModalType)}
                revertResult={onRevert}
            />

            <div ref={contentReference} className="text-block">
                {sentencesWithMergedMarks.map((word, index) => (
                    <Word
                        {...word}
                        key={generateReactKey(index)}
                        sentenceLength={listOfSentences.length}
                        contentReference={contentReference}
                        widget={getWidget(index)}
                        wordPosition={index}
                        startPosition={startPosition}
                        endPosition={mergedEndPosition}
                        onClickHandler={onClickHandler}
                        getMarksClassNames={getMarksClassNames}
                        onPressHoldHandler={onPressHoldHandler}
                    />
                ))}
            </div>
        </div>
    );
};

TroBookContent.defaultProps = {
    getWidget: () => {},
    listOfSentences: [],
    startPosition: null,
    mergedEndPosition: null,
    confirmationModalType: null,
    setEditMode: () => {},
    onRevert: () => {},
    closeConfirmationPopup: () => {},
    onClickHandler: () => {},
    onPressHoldHandler: () => {},
    getMarksClassNames: () => {},
};

TroBookContent.propTypes = {
    getWidget: PropTypes.func,
    listOfSentences: PropTypes.array,
    startPosition: PropTypes.number,
    mergedEndPosition: PropTypes.number,
    confirmationModalType: PropTypes.string,
    setEditMode: PropTypes.func,
    onClickHandler: PropTypes.func,
    onPressHoldHandler: PropTypes.func,
    onRevert: PropTypes.func,
    closeConfirmationPopup: PropTypes.func,
    getMarksClassNames: PropTypes.func,
};

export default TroBookContent;
